import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_BASE_URL } from '@core/injectors';
import { Observable } from 'rxjs';
import { OpenTicketsDTO, ProcessIssuesDTO } from '../../models';

@Injectable()
export class IssuesDashboardDataService {
  constructor(
    private readonly http: HttpClient,
    @Inject(API_BASE_URL) private readonly apiBaseUrl: string,
  ) {}

  getProcessIssues(
    page: number,
    page_size: number,
    ordering: string,
    search: string = '',
    objectType: string = '',
    status: string = '',
    customerName: string = '',
    objectName: string = '',
  ): Observable<ProcessIssuesDTO> {
    const params: Record<string, string | number> = { page, page_size };
    if (ordering) params['ordering'] = ordering;
    if (search) params['search'] = search;
    if (objectType) params['object_type'] = objectType;
    if (status) params['status'] = status;
    if (customerName) params['customer_name'] = customerName;
    if (objectName) params['object_name'] = objectName;

    return this.http.get<ProcessIssuesDTO>(`${this.apiBaseUrl}/api/issues-dashboard/`, { params });
  }

  getTickets(
    page: number,
    page_size: number,
    ordering: string,
    search: string = '',
    status: string = '',
    zendeskId: string = '',
    subject: string = '',
    customerName: string = '',
  ): Observable<OpenTicketsDTO> {
    const params: Record<string, string | number> = { page, page_size };
    if (ordering) params['ordering'] = ordering;
    if (search) params['search'] = search;
    if (status) params['status'] = status;
    if (zendeskId) params['zendesk_id'] = zendeskId;
    if (subject) params['subject'] = subject;
    if (customerName) params['customer_name'] = customerName;

    return this.http.get<OpenTicketsDTO>(`${this.apiBaseUrl}/api/tickets-dashboard/`, { params });
  }
}
